const OpportunityTableSkeleton = () => {
    return (
        <div className="overflow-x-auto">
        <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
            <thead>
                <tr className="text-gray-400 border-t">
                    <th key="header-id" className="p-4 border-b text-center w-[5%]">ID</th>
                    <th key="header-name" className="p-4 border-b text-left w-[25%]">Account</th> 
                    <th key="header-oppname" className="p-4 border-b text-left w-[25%]">Opportunity / Remarks / Referred Company</th>
                    <th key="header-product" className="p-4 border-b text-center w-[10%]">Product</th>
                    <th key="header-statusname" className="p-4 border-b text-center w-[20%]">Opportunity Status</th>
                    <th key="header-action" className="p-4 border-b text-center w-[5%]">Action</th>
                </tr>
            </thead>
            <tbody>
            {[...Array(5)].map((_, index) => (
                <tr key={index} className="hover:bg-gray-100">
                    <td className="py-2 px-4 border-b">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-2 px-4 border-b">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-2 px-4 border-b">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-2 px-4 border-b">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-2 px-4 border-b">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                    <td className="py-2 px-4 border-b">
                        <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
        </div>
    );
};

export {OpportunityTableSkeleton}